<template>
  <footer class="footer">
    <div class="wrapper">
      <div class="info">
        <div class="logo">
          <img src="../images/logo_black.svg" alt="" class="logo__img" />
        </div>

        <div class="legal desc">
          {{ $parent.legalInfo }}
        </div>
      </div>

      <div class="contacts">
        <div class="contact-us">
          <div class="contact-us__title">Contact Us:</div>
          <div class="contact-us__email">
            <a :href="`mailto:${$parent.companyEmail}`">{{
              $parent.companyEmail
            }}</a>
          </div>
        </div>

        <div class="follow-us" v-if="!$parent.socialLinks">
          <div class="follow-us__title">Follow Us On:</div>
          <div class="follow-us__links">
            <a
              v-for="{ link, img } in $parent.socialLinks"
              :href="link"
              :key="link"
              target="_blank"
            >
              <img class="link-img" :src="img" alt="" />
            </a>
          </div>
        </div>
      </div>

      <div class="links">
        <router-link :to="{ name: 'Home' }">Home</router-link>
        <router-link :to="{ name: 'BuyCrypto' }">Buy Crypto</router-link>
        <router-link :to="{ name: 'Faq' }">FAQ</router-link>
        <router-link
          v-for="{ id, title, slug } in $parent.textPageList"
          :key="slug || id"
          :to="slug
            ? { name: 'StaticPageBySlug', params: { slug } }
            : { name: 'TextPage', params: { id } }"
        >
          {{ title }}
        </router-link>
      </div>

      <div class="start-trading title">
        <div class="start-trading__title">Start trading Now</div>

        <router-link
          v-if="$parent.isAuth"
          :to="{ name: 'BuyCrypto' }"
          class="start-trading__button button black"
        >
          Get started
        </router-link>
        <button
          v-else
          @click="$parent.openSignInModal"
          class="start-trading__button button black"
        >
          Get started
        </button>

        <div class="start-trading__payment_systems">
          <img src="../images/mc.svg" alt="" />
          <img src="../images/visa.svg" alt="" />
        </div>
      </div>
    </div>

    <div class="warning desc">
      Bergistus sp.z.o.o. is registered as a Virtual Asset Service Provider (VASP) in the Register of Virtual Currency Activities maintained by the Polish Financial Supervision Authority (Komisja Nadzoru Finansowego – KNF), under registration number RDWW-1290. All content on this website is provided for general information and educational purposes only and does not constitute investment, financial, legal, or tax advice, nor a recommendation or solicitation to buy, sell, stake, or hold any cryptoasset or to engage in any specific trading strategy. Cryptoasset markets are highly volatile and may result in partial or total loss of funds. Past performance is not indicative of future results. Users are solely responsible for assessing risks and complying with applicable laws, including tax obligations. This website is not intended for use in jurisdictions where such use would be unlawful. Products and services offfered on the platform are subject to jurisdictional limitations and applicable regulatory requirements and may not be available in all regions. By accessing or using the platform, you agree to our Terms of Service, Privacy Policy, and applicable legal disclosures.
    </div>
    <!--      <ul class="nav">-->
    <!--        <template v-for="item in $parent.footerNav">-->
    <!--          <li class="nav__item" :key="item.title">-->
    <!--            <router-link class="desc" :to="item.path">-->
    <!--              {{ item.title }}-->
    <!--            </router-link>-->
    <!--          </li>-->
    <!--        </template>-->
    <!--        <template v-for="item in $parent.textPageList">-->
    <!--          <li class="nav__item" :key="item.id">-->
    <!--            <a class="desc" @click="$parent.goToPage(item)">-->
    <!--              {{ item.title }}-->
    <!--            </a>-->
    <!--          </li>-->
    <!--        </template>-->
    <!--      </ul>-->
    <!--      <div class="social-links">-->
    <!--        <div v-for="link in $parent.socialLinks" :key="link.img" class="social-links__link">-->
    <!--          <a :href="link.link">-->
    <!--            <img :src="link.img" :alt="link.link"/>-->
    <!--          </a>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div v-if="$parent.legalInfo" class="desc legal-info">{{ $parent.legalInfo }}</div>-->
    <!--      <div class="desc legal-info">© 2024 All Rights Reserved</div>-->
    <!--      <div v-if="hasCountryObject" class="nav__item allowed-countries">-->
    <!--        <a @click="$parent.goToAllowedCountries" class="desc">-->
    <!--          Allowed countries-->
    <!--        </a>-->
    <!--      </div>-->
    <!--      <ul class="payment-list">-->
    <!--        <li class="item">-->
    <!--          <img src="./../images/mc.svg" class="img"/>-->
    <!--        </li>-->
    <!--        <li class="item">-->
    <!--          <img src="./../images/visa.svg" class="img"/>-->
    <!--        </li>-->
    <!--      </ul>-->
    <!--    <div class="wrapper wrapper_social">-->
    <!--      <div class="social-links">-->
    <!--        <div v-for="link in $parent.socialLinks" :key="link.img" class="social_links__link">-->
    <!--          <a :href="link.link">-->
    <!--            <img :src="link.img" :alt="link.link"/>-->
    <!--          </a>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--		<div class="wrapper legal-info">-->
    <!--			<div v-if="$parent.legalInfo" class="desc">{{$parent.legalInfo}}</div>-->
    <!--			<div class="list">-->
    <!--				<div class="item" v-if="$parent.phone">-->
    <!--					<div class="desc">Phone:</div>-->
    <!--					<a :href="'tel:' + $parent.phone" class="desc">{{$parent.phone}}</a>-->
    <!--				</div>-->
    <!--				<div class="item" v-if="$parent.email">-->
    <!--					<div class="desc">E-mail:</div>-->
    <!--					<a :href="'mailto:' + $parent.email" class="desc">{{$parent.email}}</a>-->
    <!--				</div>-->
    <!--			</div>-->
    <!--		</div>-->
    <!--		<div class="wrapper">-->
    <!--			<div class="desc">© 2023 All Rights Reserved</div>-->
    <!--			<ul class="list">-->
    <!--				<li class="item">-->
    <!--				<img src="./../images/mc.svg" class="img"/>-->
    <!--				</li>-->
    <!--				<li class="item">-->
    <!--				<img src="./../images/visa.svg" class="img"/>-->
    <!--				</li>-->
    <!--				<li class="item">-->
    <!--				<img src="./../images/3ds.png" class="img"/>-->
    <!--				</li>-->
    <!--			</ul>-->
    <!--		</div>-->
  </footer>
</template>

<script>
export default {
  name: "Footer",
  props: [],
  data: function () {
    return {
      // legalInfo: '',
      // email: '',
      // phone: ''
    };
  },
  methods: {},
  computed: {
    hasCountryObject() {
      return this.$parent.textPageList.some(
        (obj) => obj.hasOwnProperty("is_countries") && obj.is_countries === 1
      );
    },
  },
  mounted() {
    // this.$http.get(process.env.VUE_APP_API + 'settings')
    // .then((res) => {
    // 	this.legalInfo = res.data.payload.legal_info;
    // 	this.email = res.data.payload.support_email;
    // 	this.phone = res.data.payload.support_phone;
    // })
    // .catch(() => {
    //
    // })
  },
};
</script>
